<template>
  <div class="avue-sidebar">
    <el-scrollbar style="height: 100%">
      <div class="left-menu">
        <img
          class="item2"
          src="@/assets/menu/logo.png"
          style="width:63px;height:58px;display: inline-block;"
        />
      </div>
      <el-menu
        unique-opened
        :default-active="nowTagValue"
        mode="vertical"
        :show-timeout="200"
        :collapse="keyCollapse"
      >
        <sidebar-item
          :menu="menu"
          :propscreen="screen"
          first
          :nowTagValue="nowTagValue"
          :props="{
            label: 'name',
            path: 'path',
            icon: 'source',
            children: 'children'
          }"
          :collapse="keyCollapse"
        ></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sidebarItem from "./sidebarItem";
import admin from "@/utils/admin";
export default {
  name: "sidebar",
  components: { sidebarItem },
  data() {
    return { menu: [] };
  },
  created() {
    // console.log("createdxxxxxxxxx")
    this.$store.commit("SET_SCREEN", admin.getScreen());
    this.menu = this.$store.state.vuex_antRouter;
    // console.log(this.nowTagValue, "nowTagValue", this.menu);
  },
  computed: {
    ...mapGetters(["tag", "keyCollapse", "screen", "menuId"]),
    nowTagValue: function() {
      var getValue = function(route) {
        let value = "";
        if (route.query.src) {
          value = route.query.src;
        } else {
          value = route.path;
        }
        return value;
      };
      return getValue(this.$route);
    }
  },
  methods: {
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/style/sidebar.scss";
.el-menu-item {
  padding: 0;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px; //左侧导航栏 一级菜单 设置字体大小为14px
}
.el-menu-item,
.el-submenu__title {
  line-height: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue